import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AuthenticationService } from '../../../services/authentication.service'
import * as firebase from 'firebase/auth'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { ClientService } from '../../../services/client.service'
import { GoogleTagManagerService } from 'angular-google-tag-manager'
import { GlobalService } from '../../../services/global.service'
import User = firebase.User

@Component({
    selector: 'app-bookupp-header',
    templateUrl: './bookupp-header.component.html',
    styleUrls: ['./bookupp-header.component.scss'],
})
export class BookuppHeaderComponent implements OnInit {
    @Input() showFindParking = true
    @Input() sideMenuButton = false
    @Output() onSideMenu = new EventEmitter<void>()

    user: User | null
    returnUrl: string | null
    activeMerchant: any
    logoUrl: string = 'assets/images/branding/allocate-white.png'
    headerClass: string = 'navbar-dark bg-dark'
    headerPaddingClass = ''

    constructor(
        public globalService: GlobalService,
        public authService: AuthenticationService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public clientService: ClientService,
        private gtmService: GoogleTagManagerService
    ) {
        this.activatedRoute.queryParams.forEach((queryParams) => {
            if (queryParams['returnUrl']) {
                this.returnUrl = queryParams['returnUrl']
            } else {
                this.returnUrl = null
            }
        })

        // Track each page view event
        this.router.events.forEach((item) => {
            if (item instanceof NavigationEnd) {
                const gtmTag = {
                    event: 'page',
                    pageName: item.url,
                }
                this.gtmService.pushTag(gtmTag)
            }
        })

        // Standard BookUpp header styling
        // Enterprise pages use dedicated header components (e.g., app-redefine-header)
        document.documentElement.style.setProperty('--whitelabel-header-color', '#001533')
    }

    ngOnInit(): void {
        this.authService.auth.onAuthStateChanged((user) => {
            this.user = user
        })
    }

    ngOnDestroy(): void {}

    signOut() {
        this.authService
            .signOut()
            .then(() => {
                this.router.navigate([''])
            })
            .catch((e) => {
                console.log(e.message)
            })
        return false
    }

    onMerchantPortal() {
        this.router.navigate([`merchant/portfolios`])
        return false
    }

    onClientProfile() {
        if (this.clientService.requiresProfileCompletion(this.clientService.activeClient)) {
            this.router.navigate([`client/create`])
        } else {
            this.router.navigate([`client/${this.authService.uid}`])
        }
        return false
    }

    onSignIn() {
        if (this.returnUrl) {
            this.router.navigate(['sign-in'], { queryParams: { returnUrl: this.returnUrl } })
        } else {
            this.router.navigate(['sign-in'])
        }
        return false
    }

    onSignUp() {
        if (this.returnUrl) {
            this.router.navigate(['sign-up'], { queryParams: { returnUrl: this.returnUrl } })
        } else {
            this.router.navigate(['sign-up'])
        }
        return false
    }

    onFindParking() {
        this.router.navigate(['/map-search'])
    }

    goHome() {
        this.router.navigate(['/bookupp'])
    }
}
